module.exports = __webpack_public_path__ + "media/ruoyi_04_最高的地方.523f7ad0.wav";